module.exports = __webpack_public_path__ + "static/media/animated_kevin.eaf02c2d.png";